import React, { useState } from 'react';
import { PinIcon, PhoneIcon, MailIcon, MessageIcon, ClockIcon } from '../components/common/Icons';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const scriptUrl = 'https://script.google.com/macros/s/AKfycbySzawcOmj6e5M5iC4GHBI_Pk6RCyEcx8TVNaKrXlordSsF9k63Pu3kn0u4F-6QDiwSqw/exec';

    try {
      // Using URLSearchParams for better compatibility with Google Apps Script
      const params = new URLSearchParams();
      for (const key in formData) {
        params.append(key, formData[key]);
      }

      await fetch(scriptUrl, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params.toString(),
      });

      alert('Thank you for your enquiry. Your message has been sent successfully!');
      setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
    } catch (error) {
      console.error('Error!', error.message);
      alert('Oops! Something went wrong. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      <section className="page-header">
        <div className="container">
          <h1>Contact Us</h1>
          <p>Get in touch with Neha Shuttering for expert advice and competitive quotes.</p>
        </div>
      </section>

      <section className="section">
        <div className="container grid grid-2">
          {/* Contact Info */}
          <div className="contact-info">
            <h2>Get In Touch</h2>

            <div className="info-item">
              <div className="icon"><PinIcon /></div>
              <div>
                <h4>Our Address</h4>
                <p>Khewat No.592, Khata No.755, Killa No.8221, </p>
                <p>Shaheed Major Vikash Yadav Marg, Near NH-8, Jharsa Chowk, Gurgaon-122001 (HR)</p>
              </div>
            </div>

            <div className="info-item">
              <div className="icon"><PhoneIcon /></div>
              <div>
                <h4>Call Us</h4>
                <p>+91 9811949911</p>
                <p>+91 9810664832</p>
              </div>
            </div>

            <div className="info-item">
              <div className="icon"><MailIcon /></div>
              <div>
                <h4>Email Us</h4>
                <p>info@nehashuttering.com</p>
              </div>
            </div>

            <div className="info-item">
              <div className="icon"><MessageIcon /></div>
              <div>
                <h4>WhatsApp</h4>
                <p>+91 9911949911</p>
              </div>
            </div>

            <div className="info-item">
              <div className="icon"><ClockIcon /></div>
              <div>
                <h4>Business Hours</h4>
                <p>Mon - Sat: 9:00 AM - 7:00 PM</p>
                <p>Sunday: Closed</p>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="contact-form-container">
            <form className="contact-form" onSubmit={handleSubmit}>
              <h3>Send an Enquiry</h3>

              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  required
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone Number"
                  required
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <input
                  type="text"
                  name="subject"
                  placeholder="Subject"
                  required
                  value={formData.subject}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <textarea
                  name="message"
                  placeholder="How can we help you?"
                  rows="5"
                  required
                  value={formData.message}
                  onChange={handleChange}
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary w-100" disabled={isSubmitting}>
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="map-section">
        <div className="map-placeholder-large">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3507.9456747201466!2d77.03907407549418!3d28.451053975764424!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjjCsDI3JzAzLjgiTiA3N8KwMDInMjkuOSJF!5e0!3m2!1sen!2sin!4v1787774757259!5m2!1sen!2sin"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
            title="Google Map"
          ></iframe>
        </div>
      </section>
    </div>
  );
};
export default Contact;